(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isHomepage = this.dataset.isHomepage === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');

        const isHomepageTop = this.isHomepage && window.scrollY === 0;

        if (isHomepageTop) {
          this.classList.remove('scrolled');
        } else {
          this.classList.add('scrolled');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.ensureInitialStateHandler = this.ensureInitialScrolledState.bind(this);
      this.userHasScrolled = window.scrollY > 0;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('load', this.ensureInitialStateHandler);

      this.createObserver();
      this.ensureInitialScrolledState();
      this.watchMegaMenuToggle();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.ensureInitialStateHandler);
      if (this.ensureInitialStateTimeout) {
        clearTimeout(this.ensureInitialStateTimeout);
      }
      if (this.homepageTopInterval) {
        clearInterval(this.homepageTopInterval);
      }
      if (this.megaMenuObserver) {
        this.megaMenuObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        this.ensureInitialScrolledState();
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    watchMegaMenuToggle() {
      this.megaMenuObserver = new MutationObserver(() => {
        if (this.isMegaMenuOpen()) {
          this.classList.add('scrolled');
        } else if (window.scrollY <= (this.headerBounds?.top ?? 0)) {
          this.classList.remove('scrolled');
        }
      });

      this.megaMenuObserver.observe(this.header, {
        attributes: true,
        attributeFilter: ['data-toggle', 'open'],
        subtree: true,
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.userHasScrolled && scrollTop > 0) {
        this.userHasScrolled = true;
        if (this.ensureInitialStateTimeout) {
          clearTimeout(this.ensureInitialStateTimeout);
        }
        if (this.homepageTopInterval) {
          clearInterval(this.homepageTopInterval);
          this.homepageTopInterval = null;
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const megaMenuOpen = this.isMegaMenuOpen();

      if (megaMenuOpen) {
        this.classList.add('scrolled');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.classList.remove('scrolled');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.classList.add('scrolled');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.classList.add('scrolled');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    ensureInitialScrolledState() {
      if (!this.isHomepage) return;

      const atTop = window.scrollY <= (this.headerBounds?.top ?? 0);

      if (atTop) {
        if (!this.isMegaMenuOpen()) {
          this.classList.remove('scrolled');
          this.header?.classList.remove('scrolled-past-header');
        }
      }

      if (!this.userHasScrolled) {
        if (this.ensureInitialStateTimeout) {
          clearTimeout(this.ensureInitialStateTimeout);
        }

        this.ensureInitialStateTimeout = setTimeout(() => {
          if (!this.userHasScrolled) {
            this.ensureInitialScrolledState();
          }
        }, 150);
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        const isHomepageTop = this.isHomepage && window.scrollY <= (this.headerBounds?.top ?? 0);

        if (isHomepageTop) {
          this.classList.remove('scrolled');
          this.header.classList.remove('scrolled-past-header');
        }

        return;
      }

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (!this.isMegaMenuOpen()) {
        this.classList.remove('scrolled');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    isMegaMenuOpen() {
      const megaMenuOpen = Boolean(document.querySelector('.mega-menu__content[data-toggle="open"]'));
      const mobileMenuOpen = Boolean(document.querySelector('.menu-drawer-container[open]'));
      return megaMenuOpen || mobileMenuOpen;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
